import {
    Box,
    Button,
    Grid,
    makeStyles,
    Paper,
    Typography,
  } from "@material-ui/core";
  import instance from "api/globalaxios";
  import Axios from "axios";
  import { format } from "date-fns";
  import CircularCenteredLoader from "features/common/CircularCenteredLoader";
  import debounce from "lodash.debounce";
  import React, { useCallback, useEffect, useState } from "react";
  import { useDispatch } from "react-redux";
  import { useHistory } from "react-router-dom";
  import { isMuthoot } from "Routes/Routes";
import Tabs from "features/Tabs/Tabs";
import { Add } from "@material-ui/icons";
import "react-nice-dates/build/style.css";
import { isValidNumber, isValidDate, getOpenClosedStatus } from 'features/disputes/MuthootDisputes/utils';
import DisputeRowMuthootUser from "./DisputeRowMuthootUser";
import { Pagination } from "@material-ui/lab";
  
  const useStyles = makeStyles((theme) => ({
    root: {
      padding: "3rem",
      [theme.breakpoints.down("sm")]: {
        padding: "1.5rem",
      },
    },
    sidebar: {
      padding: "1rem",
      userSelect: "none",
      [theme.breakpoints.down("sm")]: {
        padding: "0",
      },
    },
    content: {
      [theme.breakpoints.down("sm")]: {
        marginTop: "3rem",
      },
    },
    bigheading: {
      color: isMuthoot ? 'black' : "#4F4F4F",
      // fontFamily: `'Inter',sans-serif`,
      fontWeight: "400",
      fontSize: "24px",
      lineHeight: "36px",
      textTransform: "capitalize",
      [theme.breakpoints.down("xs")]: {
        fontSize: "20px",
      },
    },
    searchbar: {
      border: "none",
      background: "#DADBDB",
      width: "-webkit-fill-available",
      color: "#828282",
      fontSize: "14px",
      outline: "none",
      padding: "0rem 1.5rem",
      height: "42px",
      [theme.breakpoints.down("xs")]: {
        fontSize: "12px",
        height: "34px",
        padding: "0rem 0.7rem",
      },
    },
    typeButton: {
      textTransform: "none",
      border: "1px solid #4F4F4F",
      borderRadius: "0",
      padding: "0 1.5rem",
      color: "#4F4F4F",
      backgroundColor: 'white',
      fontWeight: "400",
      fontSize: "16px",
      lineHeight: "18px",
      height: "42px",
  
      [theme.breakpoints.down("xs")]: {
        height: "34px",
        fontSize: "14px",
      },
    },
    typeButtonBlue: {
      textTransform: "none",
      border: "1px solid",
      borderColor: theme.palette.primary.main,
      background: isMuthoot ? theme.palette.primary.main : "#2F80ED",
      borderRadius: "0",
      padding: "0 1.5rem",
      color: "#fff",
      // fontFamily: `'Inter',sans-serif`,
      fontWeight: "400",
      fontSize: "16px",
      lineHeight: "18px",
      height: "42px",
      "&:hover": {
        background: "#FFFFFF",
        color: isMuthoot ? theme.palette.primary.main : "#2F80ED",
        border: "1px solid",
        borderColor: theme.palette.primary.main,
      },
      [theme.breakpoints.down("xs")]: {
        height: "34px",
        fontSize: "14px",
      },
    },
    typechoices: {
      color: "#333333",
      fontFamily: `'Inter',sans-serif`,
      fontWeight: "400",
      fontSize: "14px",
      lineHeight: "18px",
      textTransform: "capitalize",
      paddingRight: "5px",
      [theme.breakpoints.down("xs")]: {
        fontSize: "12px",
      },
    },
    typeFormControl: {
      margin: 0,
      "&:hover": {
        background: "#E0E0E0",
      },
    },
    spaceBox: {
      height: "4rem",
      [theme.breakpoints.down("sm")]: {
        height: "3rem",
      },
      [theme.breakpoints.down("xs")]: {
        height: "2rem",
      },
    },
    griditem: {
      padding: "8px",
      [theme.breakpoints.down("xs")]: {
        padding: "4px",
      },
    },
    title: { 
      fontFamily: 'Satoshi-Bold',
      fontSize: "14px",
      lineHeight: "17px",
      [theme.breakpoints.down("sm")]: {
        fontSize: "0.9rem",
        lineHeight: "1.2rem",
      },
    },
    value: {
      fontSize: "14px",
      lineHeight: "17px",
      textTransform: "capitalize",
      "&:hover": {
        background: "#E0E0E0",
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: "0.9rem",
        lineHeight: "1.2rem",
      },
    },
    titlePaper: {
      padding: "1.5rem",
      boxShadow: "none",
      width: "100%",
      backgroundColor: "initial",
      [theme.breakpoints.down("sm")]: {
        textAlign: "center",
      },
    },
    valuePaper: {
      padding: "1.5rem",
      cursor: "pointer",
      boxShadow: "none",
      width: "100%",
      border: "1px solid #E0E0E0",
      "&:hover": {
        background: "#E0E0E0",
      },
      [theme.breakpoints.down("sm")]: {
        textAlign: "center",
      },
    },
    menuwidth: {
      width: "200px",
      [theme.breakpoints.down("sm")]: {
        width: "150px",
      },
      [theme.breakpoints.down("xs")]: {
        width: "130px",
      },
    },
    alginCenter: {
      textAlign: "center",
    },
    tabsContainer: {
      border: '1px solid black',
      [theme.breakpoints.down("sm")]: {
        width: '100%',
        flexWrap: 'wrap',
      },
    },
    selected: {
      padding: "9.8px 14.7px",
      cursor: 'pointer',
      fontSize: '14.7px',
      fontFamily: 'Satoshi-Medium',
      minWidth: 'fit-content',
      textAlign: 'center',
      backgroundColor: 'white',
    },
    unselected: {
      fontSize: '14.7px',
      padding: "9.8px 14.7px",
      cursor: "pointer",
      fontFamily: 'Satoshi-Medium',
      minWidth: 'fit-content',
      textAlign: 'center',
    },
  }));
  
  
  export default function DisputesMuthootUser({
    // count,
    disputesLoading,
    setType,
    type,
    disputes,
    reload,
    totalPages,
    page,
    setPage,
    getUserDataAnotherPage,
    profile,
  }) {
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch();
    const [searchText, setSearchText] = useState("");
    const [disputesBySearch, setDisputesBySearch] = useState(disputes);
    const [cancelToken, setCancelToken] = useState();
  
    const debouceSearch = useCallback(debounce(search, 500), [disputes]);
  
    useEffect(() => {
      setDisputesBySearch(disputes);
    }, [disputes]);
  
    function search(value, type) {
      //Check if there are any previous pending requests
      if (typeof cancelToken != typeof undefined) {
        cancelToken.cancel("Operation canceled due to new request.");
      }
      //Save the cancel token for the current request
      let x = Axios.CancelToken.source();
      setCancelToken(x);
  
      if (value.trim() != "") {
        let ar = value.trim().split("-");
        let date = new Date(ar[1] + "/" + ar[0] + "/" + ar[2]);
        if (isValidDate(date)) {
          dispatch(getMuthootdatabydate(date, x, type));
        } else if (isValidNumber(value.trim())) {
          dispatch(getMuthootdatabyDisputeId(value.trim(), x, type));
        } 
      } else {
        setDisputesBySearch(disputes);
      }
    }

    function getMuthootdatabydate(date, cancelToken, type=null, region=null) {
      return async (dispatch) => {
        try {
          const response = await instance.get(
            `api/muthootsearchbydateView/${format(
              date,
              "dd-MM-yyyy"
            )}/?type=${type}&region=${region}`,
            { cancelToken: cancelToken.token }
          );
          setDisputesBySearch(response.data);
  
          return response.data;
        } catch (error) {
          console.log(error);
        }
      };
    }

    function getMuthootdatabyDisputeId(value, cancelToken, type=null, region=null, days=null) {
      return async (dispatch) => {
        try {
          const response = await instance.get(
            `/api/muthootsearchbydisputeidView/${value}/?type=${type}&region=${region}&days=${days}`,
            { cancelToken: cancelToken.token }
          );
          setDisputesBySearch(response.data);
  
          return response.data;
        } catch (error) {
          console.log(error);
        }
      };
    } 

    const tabs = [
      {
        id: "open",
        label: "In progress",
      },
      {
        id: "closed",
        label: "Closed",
      },
    ];

    const [currentTab, setCurrentTab] = useState(type);

    const handleTabChange = (newValue) => {
      setCurrentTab(newValue);
      setType(newValue);
      setSearchText("");
      setPage(1);
      sessionStorage.setItem("muthoot-type", newValue);
    };
  
    return (
      <>
        <Grid container className={classes.root}>
          <Box className={classes.spaceBox} />
          {disputesLoading ? (
            <CircularCenteredLoader />
          ) : (
            <>
              <Grid container>
                <Grid
                  item
                  className={classes.griditem}
                  style={{ paddingLeft: 0, flex: 1, }}
                >
                  <input
                    type="text"
                    placeholder="Search by Date (DD-MM-YYYY) or G.ID"
                    value={searchText}
                    onChange={(e) => {
                      setSearchText(e.target.value);
                      debouceSearch(e.target.value, type);
                    }}
                    onBlur={(e) => {
                      e.target.placeholder =
                        "Search by Date (DD-MM-YYYY) or G.ID";
                    }}
                    className={classes.searchbar}
                    onFocus={(e) => (e.target.placeholder = "")}
                  />
                </Grid>
                <Grid item className={classes.griditem}>
                  <Tabs
                    tabs={tabs}
                    handleClickTab={handleTabChange}
                    choice={currentTab}
                    tabsClasses={{
                      selected: classes.selected,
                      unselected: classes.unselected,
                    }}
                    tabsContainerClass={classes.tabsContainer}
                  />
                </Grid>
                <Grid item className={classes.griditem}>
                  <Box>
                    <Button
                      variant="contained"
                      color="primary"
                      startIcon={<Add/>}
                      onClick={() => {
                        history.push("/intro");
                      }}
                      style={{fontSize:'14px',padding:'9px 14.7px'}}
                    >
                      FILE NEW
                    </Button>
                  </Box>
                </Grid>
              </Grid>
              {/* Disputes list starts from here */}
              <Box className={classes.spaceBox}></Box>
              <Grid container style={{ rowGap: "8px" }}>
                <Paper className={classes.titlePaper} square>
                  <Grid container spacing={2} justifyContent="flex-start">
                  <>
                    <Grid item xs sm={1}>
                      <div style={{display:'flex',alignItems:'center'}}>
                        <Typography className={classes.title}>
                          G. ID
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xs sm={8}>
                      <Typography className={classes.title}>
                        COMPLAINT DETAILS
                      </Typography>
                    </Grid>
                    <Grid item xs sm={1}>
                      <Typography className={classes.title} style={{textAlign: 'center'}}>
                        Status
                      </Typography>
                    </Grid>
                    <Grid item xs sm={2}>
                      <Typography className={classes.title} style={{textAlign: 'left'}}>
                        Date & Time
                      </Typography>
                    </Grid>
                  </>
                  </Grid>
                </Paper>
                {disputesBySearch.length !== 0 ? (
                  disputesBySearch.map((dispute) => {
                    return (
                      <DisputeRowMuthootUser
                        id={dispute.id}
                        filingDate={dispute.created}
                        history={history}
                        complaint_details={dispute.description}
                        status={getOpenClosedStatus(dispute?.status)}
                      />
                    );
                  })
                ) : (
                  <Grid container justifyContent="center">
                    <Grid item>
                      <Box textAlign="center">
                        <Typography
                          style={{
                            fontWeight: 500,
                            fontSize: "initial",
                          }}
                        >
                          Dispute does not exist.
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                )}
              </Grid>
              <Box height="10px"></Box>
              {disputesBySearch.length !== 0 && !searchText && (
                <div style={{display: 'flex', justifyContent: 'right', padding: '1rem 0', width: '100%'}}>
                  <Pagination color="primary" page={page} count={totalPages} onChange={(event, value)=>getUserDataAnotherPage(value)}/>
                </div>
              )}
            </>
          )}
        </Grid>
      </>
    );
  }
  